import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { countryData } from '../../mui-components/phone-input/phone-input.data';
import { getCountryPhoneLengths, PHONE_DIGITS_RANGE } from '../../mui-components/phone-input/phone-input.utility';
import * as Yup from 'yup';

export const useValidationSchemaPhone = () => {
  const { t, i18n } = useTranslation();

  return useMemo(() => {
    const listFormat = new Intl.ListFormat(i18n.language, { type: 'disjunction' });

    return Yup.string()
      .trim()
      .test('phoneFormat', function (value) {
        if (!value) return true;

        const country = countryData.find((item) => item.isoCode === this.parent.country);
        if (!country) return this.createError({ message: t('errors.invalidPhoneFormat', PHONE_DIGITS_RANGE) });

        const lengths = getCountryPhoneLengths(country);
        const isValid =
          /^\d+$/.test(value) && lengths.includes(value.length) && `+${value}`.startsWith(country.dialCode);

        return (
          isValid ||
          this.createError({
            message: t('errors.invalidPhoneFormatForCountry', { digits: listFormat.format(lengths.map(String)) }),
          })
        );
      });
  }, [t, i18n.language]);
};
